import { HOURS_PER_DAY } from '../../constants';
import { fetchDayTimesheets, saveTimesheetDay } from '../../services/timesheets';
import { notify } from '../../store/feedback';
import { fmtHours } from '../../utils/hours';
import { dayRows, rowsMissingPhase } from './dayDraft';
import { manualDayOverflow } from './dayLimit';

/* Enregistrement de la saisie d'une journée. Ajout et suppression des lignes se font en une seule
   transaction côté base (save_timesheet_day), qui applique aussi le plafond de 7h : le contrôle
   ci-dessous n'évite qu'un aller-retour et donne un message clair. */
export default function timesheetsSaveDayHandlers(deps, api) {
  const {
    profile,
    session,
    setTimesheetDay,
    timesheetDayDraft,
    timesheetDay,
    timesheetUserId,
    timesheetMonth,
  } = deps;

  async function saveDayEntries() {
    if (rowsMissingPhase(timesheetDayDraft).length) {
      notify('Choisis une phase pour chaque ligne avant d’enregistrer.');
      return;
    }
    const date = timesheetDay;
    const devId = profile?.dev_id || session.user.id; // fallback sur user ID si pas de dev_id
    const { data: existing, error: readErr } = await fetchDayTimesheets(date, session);
    if (readErr) {
      notify('Erreur lors de la lecture des heures existantes : ' + readErr.message);
      return;
    }
    const rows = dayRows(timesheetDayDraft, { userId: session.user.id, devId, date });
    const overflow = manualDayOverflow(existing || [], rows);
    if (overflow !== null) {
      notify(
        `Impossible : la journée compterait ${fmtHours(overflow)} (maximum ${HOURS_PER_DAY}h en saisie).\n\n` +
          'Réduis les heures avant d’enregistrer. Les heures importées depuis Jira ne sont pas concernées.',
      );
      return;
    }
    const { error } = await saveTimesheetDay(date, rows);
    if (error) {
      notify(
        "Erreur lors de l'enregistrement : " +
          error.message +
          "\n\nTa saisie n'a pas été sauvegardée.",
      );
      return;
    }
    setTimesheetDay(null);
    api.loadTimesheetMonth(timesheetMonth, timesheetUserId);
  }

  return { saveDayEntries };
}
